import React, { useCallback } from 'react';
import { introShown } from '../redux/actions/ui';
import ReactMarkdown from 'react-markdown';
import { SubmitBar } from '../components/submit-bar';
import { IntroContent } from '../page-content/intro-content';
import { IntroData } from 'its-pages';
import Box from '@mui/material/Box';
import { useAppDispatch } from '../redux/hooks';

interface OwnProps {
  introContent: IntroContent;
}

export const Intro  = ({ introContent }: OwnProps) => {
  const dispatch = useAppDispatch();
  const pageData = introContent.pageData as IntroData;
  const introText = pageData.introText;

  const onSubmit = useCallback(() => {
    dispatch(introShown());
  }, [dispatch]);

  return (
    <Box className='Problem ProblemIntro' sx={{ maxWidth: '800px' }}>
      <ReactMarkdown className='Intro'>{introText}</ReactMarkdown>
      <SubmitBar
        onSubmit={onSubmit}
        disableSubmit={false}
        buttonText={"Let's Get Started"}
        buttonClass={'SubmitBarButton'}
      />
    </Box>
  );
}
